"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPostalCodeInValidFormat = void 0;

var Enums_1 = require("../Enums");
/**
 * Validate if the postal code is in the correct US, CA or MX format.
 * @param postalCode string
 * @returns boolean
 */


var isPostalCodeInValidFormat = function isPostalCodeInValidFormat(postalCode) {
  var usZipExp = new RegExp(Enums_1.PostalCodeRegexPatterns.usaStandardZipCode); // this will have to be split when we add feature to handle 9 digit zip codes

  var mxZipExp = new RegExp(Enums_1.PostalCodeRegexPatterns.mx);
  var caCodeExp = new RegExp(Enums_1.PostalCodeRegexPatterns.ca); // whitespace is mandatory

  return usZipExp.test(postalCode) || mxZipExp.test(postalCode) || caCodeExp.test(postalCode);
};

exports.isPostalCodeInValidFormat = isPostalCodeInValidFormat;
var PostalCodeUtilities = {
  isPostalCodeInValidFormat: exports.isPostalCodeInValidFormat
};
exports.default = PostalCodeUtilities;